import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker, type DayPickerProps } from "react-day-picker";
import { cn } from "@/lib/utils";

/** shadcn Calendar composition, adapted to this console's tokens and Base UI stack. */
export function Calendar({ className, classNames, ...props }: DayPickerProps) {
  return (
    <DayPicker
      className={cn("w-full p-0 text-ink", className)}
      classNames={{
        root: "relative w-full",
        months: "flex w-full flex-col",
        month: "w-full",
        month_caption: "mb-2 flex h-8 items-center justify-center text-xs font-semibold pointer-coarse:h-11",
        nav: "absolute inset-x-0 top-0 flex h-8 items-center justify-between pointer-coarse:h-11",
        button_previous: "inline-flex size-8 items-center justify-center rounded-full border border-transparent text-muted hover:text-ink hover:bg-panel focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-focus pointer-coarse:size-11",
        button_next: "inline-flex size-8 items-center justify-center rounded-full border border-transparent text-muted hover:text-ink hover:bg-panel focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-focus pointer-coarse:size-11",
        chevron: "size-4",
        month_grid: "w-full border-collapse",
        weekdays: "mb-1 grid grid-cols-7 w-full text-center text-[11px] text-muted",
        weekday: "flex h-6 w-full items-center justify-center font-medium",
        weeks: "w-full space-y-0.5",
        week: "grid grid-cols-7 w-full",
        day: "relative flex h-8 w-full items-center justify-center p-0 text-center pointer-coarse:h-11",
        day_button: "flex size-8 items-center justify-center rounded-full text-xs font-normal text-ink transition-colors hover:bg-panel hover:text-ink focus-visible:z-10 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-focus pointer-coarse:size-11",
        selected: "[&>button]:bg-ink! [&>button]:text-canvas! [&>button]:font-medium hover:[&>button]:bg-ink! hover:[&>button]:text-canvas!",
        today: "[&>button]:ring-1 [&>button]:ring-inset [&>button]:ring-control",
        outside: "text-muted/40",
        disabled: "text-muted/20 pointer-events-none",
        ...classNames,
      }}
      components={{ Chevron: ({ orientation }) => orientation === "left" ? <ChevronLeft /> : <ChevronRight /> }}
      {...props}
    />
  );
}
